import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';

import { Router, RouterOutlet } from '@angular/router';
import 'simplebar';
import { LoadingScreenComponent } from './components/loading-screen/loading-screen.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { SnackbarComponent } from './components/snackbar/snackbar.component';
import { DictionaryService } from './services/dictionary.service';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    CommonModule,
    LoadingScreenComponent,
    NavbarComponent,
    SnackbarComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  protected dictionaryService = inject(DictionaryService);
  protected router = inject(Router);
  constructor() {
    // Removing Initial Loading Spinner
    document.getElementById('root-loading')?.remove();

    /**
     * Related to the Select Component
     * Closes select popups whenever mouse clicks outside popup
     * Refer to select.component.ts - HostListener click event
     */
    document.querySelector('body')?.addEventListener('click', (event) => {
      if (event.target instanceof HTMLInputElement) {
        if (event.target.name.includes('checkBox')) {
          return;
        }
      }
      const selects = document.querySelectorAll('.select');
      selects.forEach((select) => {
        if (!(event.target as HTMLElement).closest(`#${select.id}`)) {
          select.classList.remove('expanded');
        }
      });
    });
  }

  /**
   * Gets the current route via the Router
   * @returns {string} The current path
   */
  getRoute = (): string => {
    return this.router.url;
  };

  ngOnInit(): void {}
}
